export default "__VITE_ASSET__bc937922__"